import type { AuthenticatedOptions } from '../api/authenticated-request-options';
import { withAuthenticatedHeaders } from '../api/authenticated-request-options';
import { peanudsApi } from '../api/http';
import type {
  GetGenericTransactionByIdData,
  GetIncomingTransferByIdData,
  GetOutgoingTransferByIdData,
  ListGenericTransactionsData,
  ListIncomingTransfersData,
  ListOutgoingTransfersData,
} from '../schemas/generated';

export const createIncomingTransfersRequestTemplate = () => {
  return {
    request: async (options?: AuthenticatedOptions<ListIncomingTransfersData>) => {
      return peanudsApi.listIncomingTransfers(
        await withAuthenticatedHeaders<ListIncomingTransfersData>(options ?? {}),
      );
    },
  };
};

export const createOutgoingTransfersRequestTemplate = () => {
  return {
    request: async (options?: AuthenticatedOptions<ListOutgoingTransfersData>) => {
      return peanudsApi.listOutgoingTransfers(
        await withAuthenticatedHeaders<ListOutgoingTransfersData>(options ?? {}),
      );
    },
  };
};

export const createGenericTransactionsRequestTemplate = () => {
  return {
    request: async (options?: AuthenticatedOptions<ListGenericTransactionsData>) => {
      return peanudsApi.listGenericTransactions(
        await withAuthenticatedHeaders<ListGenericTransactionsData>(options ?? {}),
      );
    },
  };
};

export const createIncomingTransferDetailsRequestTemplate = () => {
  return {
    request: async (options: AuthenticatedOptions<GetIncomingTransferByIdData>) => {
      return peanudsApi.getIncomingTransferById(
        await withAuthenticatedHeaders<GetIncomingTransferByIdData>(options),
      );
    },
  };
};

export const createOutgoingTransferDetailsRequestTemplate = () => {
  return {
    request: async (options: AuthenticatedOptions<GetOutgoingTransferByIdData>) => {
      return peanudsApi.getOutgoingTransferById(
        await withAuthenticatedHeaders<GetOutgoingTransferByIdData>(options),
      );
    },
  };
};

export const createGenericTransactionDetailsRequestTemplate = () => {
  return {
    request: async (options: AuthenticatedOptions<GetGenericTransactionByIdData>) => {
      return peanudsApi.getGenericTransactionById(
        await withAuthenticatedHeaders<GetGenericTransactionByIdData>(options),
      );
    },
  };
};
